<div class="title-area">
  <h2 class="title">90秒アンケート</h2>
  <div class="desc">回答期間は毎月15日0:00〜24日23:59です。</div>
</div>

@if (showSpinner) {
  <div class="spinner">
    <mat-spinner></mat-spinner>
  </div>
} @else {

  @if (isSurveyTarget) {
    <div class="table-wrap">
    <div class="table-shrink">
    <table class="survey-table member-table">
      <colgroup>
        <col class="col-month">
        <col class="col-status">
        <col class="col-count">
        <col class="col-self-score">
        <col class="col-workplace">
        <col class="col-org-score">
        <col class="col-org-score">
      </colgroup>
      <thead>
        <tr>
          <th rowspan="2" class="col-month">アンケート対象月</th>
          <th rowspan="2" class="col-status">回答状況</th>
          <th rowspan="2" class="col-count">自組織 回答数</th>
          <th rowspan="2" class="col-self-score">自身の状態</th>
          <th colspan="3">職場/店舗の状態</th>
        </tr>
        <tr>
          <th colspan="2" class="col-workplace">回答した職場/店舗</th>
          <th class="col-org-score">自組織</th>
        </tr>
      </thead>
      <tbody>
        @if (memberItems.length === 0) {
          <!-- 表示はしないが、「未回答」だけの行があるときと同じ列幅になるよう基準行を混ぜておく -->
          <tr class="width-reference-row">
            <td class="col-month">2000年00月</td>
            <td class="col-status"><a class="status-unanswered">未回答</a></td>
            <td class="col-count">{{ blank(true) }}</td>
            <td class="col-self-score">{{ blank(true) }}</td>
            <td class="col-workplace">{{ blank(true) }}</td>
            <td class="col-org-score">{{ blank(true) }}</td>
            <td class="col-org-score">{{ blank(true) }}</td>
          </tr>
        }
        @for (item of memberItems; track item.targetMonth) {
          <tr>
            <td class="col-month">
              @if (item.reportAvailable) {
                <a class="report-link" (click)="onReportClick(item.rawMonth)">{{ item.targetMonth }}</a>
              } @else {
                {{ item.targetMonth }}
              }
            </td>
            <td class="col-status">
              @if (item.status === 'unanswered') {
                <a class="status-unanswered" (click)="onAnswerClick()">未回答</a>
              } @else if (item.status === 'answered') {
                <div class="status-answered">回答済</div>
                <div class="status-date">{{ item.answeredDate }}</div>
              } @else {
                {{ blank(item.reportAvailable) }}
              }
            </td>
            <td class="col-count">
              @if (item.orgAnswerCount != null) {
                {{ item.orgAnswerCount }} / {{ item.orgAnswerTotal }}
              } @else {
                {{ blank(item.reportAvailable) }}
              }
            </td>
            <td class="col-self-score">{{ item.selfScore != null ? (item.selfScore | number:'1.1-1') : blank(item.reportAvailable) }}</td>
            <td class="col-workplace">
              @if (item.answeredWorkplace) {
                <div class="workplace-cell">
                  <span class="workplace-name">{{ item.answeredWorkplace }}</span>
                </div>
              } @else {
                {{ blank(item.reportAvailable) }}
              }
            </td>
            <td class="col-org-score">{{ item.workplaceScore != null ? (item.workplaceScore | number:'1.1-1') : blank(item.reportAvailable) }}</td>
            <td class="col-org-score">{{ item.orgWorkplaceScore != null ? (item.orgWorkplaceScore | number:'1.1-1') : blank(item.reportAvailable) }}</td>
          </tr>
        }
      </tbody>
    </table>
    <!-- タブレット・SP（1023px以下）用：1か月1枚のカード（表は非表示）。
         対象月の下を区切り線で「回答状況」「本人の状態」「職場の状態」「回答した職場/店舗」に分ける。値がない項目は詰める -->
    <div class="survey-cards">
      @for (item of memberItems; track item.targetMonth) {
        <div class="survey-card">
          <div class="card-head">
            <div class="card-month">
              @if (item.reportAvailable) {
                <a class="report-link" (click)="onReportClick(item.rawMonth)">{{ item.targetMonth }}</a>
              } @else {
                {{ item.targetMonth }}
              }
            </div>
          </div>
          @if (item.status === 'unanswered' || item.status === 'answered' || item.orgAnswerCount != null) {
            <div class="card-section">
              <div class="card-label">回答状況</div>
              <div class="card-rows">
                @if (item.status === 'unanswered' || item.status === 'answered') {
                  <div class="card-row">
                    <span class="card-sub">あなた</span>
                    <span>
                      @if (item.status === 'unanswered') {
                        <a class="status-unanswered" (click)="onAnswerClick()">未回答</a>
                      } @else {
                        回答済<span class="card-date">{{ item.answeredDate }}</span>
                      }
                    </span>
                  </div>
                }
                @if (item.orgAnswerCount != null) {
                  <div class="card-row">
                    <span class="card-sub">自組織</span>
                    <span>{{ item.orgAnswerCount }} / {{ item.orgAnswerTotal }}</span>
                  </div>
                }
              </div>
            </div>
          }
          @if (item.selfScore != null) {
            <div class="card-section">
              <div class="card-label">本人の状態</div>
              <div class="card-rows">
                <div class="card-row">
                  <span class="card-sub">あなた</span>
                  <span class="card-score">{{ item.selfScore | number:'1.1-1' }}</span>
                </div>
              </div>
            </div>
          }
          @if (item.workplaceScore != null || item.orgWorkplaceScore != null) {
            <div class="card-section">
              <div class="card-label">職場の状態</div>
              <div class="card-rows">
                @if (item.workplaceScore != null) {
                  <div class="card-row">
                    <span class="card-sub">あなた</span>
                    <span class="card-score">{{ item.workplaceScore | number:'1.1-1' }}</span>
                  </div>
                }
                @if (item.orgWorkplaceScore != null) {
                  <div class="card-row">
                    <span class="card-sub">自組織</span>
                    <span class="card-score">{{ item.orgWorkplaceScore | number:'1.1-1' }}</span>
                  </div>
                }
              </div>
            </div>
          }
          @if (item.answeredWorkplace) {
            <div class="card-section card-section-workplace">
              <div class="card-label">回答した職場/店舗</div>
              <div class="card-scroll">
                <div>{{ item.answeredWorkplace }}</div>
              </div>
            </div>
          }
        </div>
      }
    </div>
    <!-- アンケートがない場合 -->
    @if (memberItems.length === 0) {
      <div class="no-items">
        アンケートがありません。
      </div>
    }
    </div>
    </div>
  } @else {
    <div class="table-wrap">
    <div class="table-shrink">
    <table class="survey-table">
      <colgroup>
        <col class="col-month">
        <col class="col-status">
        <col class="col-count">
        <col class="col-score">
        <col class="col-score">
        @if (showOtherOrg) { <col class="col-score"> }
        <col class="col-workplaces">
        <col class="col-score">
        @if (showOtherOrg) { <col class="col-score"> }
      </colgroup>
      <thead>
        <tr>
          <th rowspan="2" class="col-month">アンケート<br>対象月</th>
          <th rowspan="2" class="col-status">回答状況</th>
          <th rowspan="2" class="col-count">自組織<br>回答数</th>
          <th [attr.colspan]="showOtherOrg ? 3 : 2">本人の状態</th>
          <th [attr.colspan]="showOtherOrg ? 4 : 3">職場/店舗の状態</th>
        </tr>
        <tr>
          <th class="col-score">担当者</th>
          <th class="col-score">自組織</th>
          @if (showOtherOrg) { <th class="col-score">他組織</th> }
          <th colspan="2" class="col-workplaces">集計した職場/店舗</th>
          <th class="col-score">自組織</th>
          @if (showOtherOrg) { <th class="col-score">他組織</th> }
        </tr>
      </thead>
      <tbody>
        @if (managerItems.length === 0) {
          <!-- 表示はしないが、データが無い行があるときと同じ列幅になるよう基準行を混ぜておく -->
          <tr class="width-reference-row">
            <td class="col-month">2000年00月</td>
            <td class="col-status">0 / 0</td>
            <td class="col-count">{{ blank(true) }}</td>
            <td class="col-score">{{ blank(true) }}</td>
            <td class="col-score">{{ blank(true) }}</td>
            @if (showOtherOrg) { <td class="col-score">{{ blank(true) }}</td> }
            <td class="col-workplaces">{{ blank(true) }}</td>
            <td class="col-score">{{ blank(true) }}</td>
            <td class="col-score">{{ blank(true) }}</td>
            @if (showOtherOrg) { <td class="col-score">{{ blank(true) }}</td> }
          </tr>
        }
        @for (item of managerItems; track item.targetMonth) {
          <tr>
            <td class="col-month">
              @if (item.reportAvailable) {
                <a class="report-link" (click)="onReportClick(item.rawMonth)">{{ item.targetMonth }}</a>
              } @else {
                {{ item.targetMonth }}
              }
              @if (item.selfAnswered) {
                <div class="self-answered-note">（アンケート回答対象）</div>
              }
            </td>
            <td class="col-status">
              @if (item.selfAnswered) {
                <div class="status-answered">回答済</div>
                <div class="status-date">{{ item.selfAnsweredDate }}</div>
              } @else if (item.answeredTotal != null) {
                {{ item.answeredCount }} / {{ item.answeredTotal }}
              } @else {
                {{ blank(item.reportAvailable) }}
              }
            </td>
            <td class="col-count">
              @if (item.orgAnswerCount != null) {
                {{ item.orgAnswerCount }} / {{ item.orgAnswerTotal }}
              } @else {
                {{ blank(item.reportAvailable) }}
              }
            </td>
            <td class="col-score">{{ item.selfScore != null ? (item.selfScore | number:'1.1-1') : blank(item.reportAvailable) }}</td>
            <td class="col-score">{{ item.orgScore != null ? (item.orgScore | number:'1.1-1') : blank(item.reportAvailable) }}</td>
            @if (showOtherOrg) {
              <td class="col-score">{{ item.otherOrgScore != null ? (item.otherOrgScore | number:'1.1-1') : blank(item.reportAvailable) }}</td>
            }
            <td class="col-workplaces">
              <!-- 集計した職場/店舗が無い場合は「-」ではなくブランクのままにする -->
              @if (item.selfAnswered) {
                @if (item.selfWorkplace) {
                  <div class="workplace-cell">
                    <span class="workplace-name">{{ item.selfWorkplace }}</span>
                  </div>
                }
              } @else if (item.workplaces?.length) {
                <div class="workplaces-cell">
                  <div class="workplaces-list">
                    @for (wp of item.workplaces; track $index) {
                      <div class="workplace-line">{{ wp }}</div>
                    }
                    @if (item.workplacesOmitted) {
                      <div class="workplace-line">など</div>
                    }
                  </div>
                </div>
              }
            </td>
            <td class="col-score">{{ item.workplaceScore != null ? (item.workplaceScore | number:'1.1-1') : blank(item.reportAvailable) }}</td>
            <td class="col-score">{{ item.orgWorkplaceScore != null ? (item.orgWorkplaceScore | number:'1.1-1') : blank(item.reportAvailable) }}</td>
            @if (showOtherOrg) {
              <td class="col-score">{{ item.otherOrgWorkplaceScore != null ? (item.otherOrgWorkplaceScore | number:'1.1-1') : blank(item.reportAvailable) }}</td>
            }
          </tr>
        }
      </tbody>
    </table>
    <!-- タブレット・SP（1023px以下）用：1か月1枚のカード（表は非表示）。
         対象月の下を区切り線で「回答状況」「本人の状態」「職場の状態」「集計した（本人が回答した月は回答した）職場/店舗」に分ける。
         本人が回答した月は「担当者」を「あなた」と表示する。値がない項目は詰める -->
    <div class="survey-cards">
      @for (item of managerItems; track item.targetMonth) {
        <div class="survey-card">
          <div class="card-head">
            <div class="card-month">
              @if (item.reportAvailable) {
                <a class="report-link" (click)="onReportClick(item.rawMonth)">{{ item.targetMonth }}</a>
              } @else {
                {{ item.targetMonth }}
              }
              @if (item.selfAnswered) {
                <span class="self-answered-note">（アンケート回答対象）</span>
              }
            </div>
          </div>
          @if (item.selfAnswered || item.answeredTotal != null || item.orgAnswerCount != null) {
            <div class="card-section">
              <div class="card-label">回答状況</div>
              <div class="card-rows">
                @if (item.selfAnswered) {
                  <div class="card-row">
                    <span class="card-sub">あなた</span>
                    <span>回答済<span class="card-date">{{ item.selfAnsweredDate }}</span></span>
                  </div>
                } @else if (item.answeredTotal != null) {
                  <div class="card-row">
                    <span class="card-sub">担当者</span>
                    <span>{{ item.answeredCount }} / {{ item.answeredTotal }}</span>
                  </div>
                }
                @if (item.orgAnswerCount != null) {
                  <div class="card-row">
                    <span class="card-sub">自組織</span>
                    <span>{{ item.orgAnswerCount }} / {{ item.orgAnswerTotal }}</span>
                  </div>
                }
              </div>
            </div>
          }
          @if (item.selfScore != null || item.orgScore != null || (showOtherOrg && item.otherOrgScore != null)) {
            <div class="card-section">
              <div class="card-label">本人の状態</div>
              <div class="card-rows">
                @if (item.selfScore != null) {
                  <div class="card-row">
                    <span class="card-sub">{{ item.selfAnswered ? 'あなた' : '担当者' }}</span>
                    <span class="card-score">{{ item.selfScore | number:'1.1-1' }}</span>
                  </div>
                }
                @if (item.orgScore != null) {
                  <div class="card-row">
                    <span class="card-sub">自組織</span>
                    <span class="card-score">{{ item.orgScore | number:'1.1-1' }}</span>
                  </div>
                }
                @if (showOtherOrg && item.otherOrgScore != null) {
                  <div class="card-row">
                    <span class="card-sub">他組織</span>
                    <span class="card-score">{{ item.otherOrgScore | number:'1.1-1' }}</span>
                  </div>
                }
              </div>
            </div>
          }
          @if (item.workplaceScore != null || item.orgWorkplaceScore != null || (showOtherOrg && item.otherOrgWorkplaceScore != null)) {
            <div class="card-section">
              <div class="card-label">職場の状態</div>
              <div class="card-rows">
                @if (item.workplaceScore != null) {
                  <div class="card-row">
                    <span class="card-sub">{{ item.selfAnswered ? 'あなた' : '担当者' }}</span>
                    <span class="card-score">{{ item.workplaceScore | number:'1.1-1' }}</span>
                  </div>
                }
                @if (item.orgWorkplaceScore != null) {
                  <div class="card-row">
                    <span class="card-sub">自組織</span>
                    <span class="card-score">{{ item.orgWorkplaceScore | number:'1.1-1' }}</span>
                  </div>
                }
                @if (showOtherOrg && item.otherOrgWorkplaceScore != null) {
                  <div class="card-row">
                    <span class="card-sub">他組織</span>
                    <span class="card-score">{{ item.otherOrgWorkplaceScore | number:'1.1-1' }}</span>
                  </div>
                }
              </div>
            </div>
          }
          @if (item.selfAnswered ? item.selfWorkplace : item.workplaces?.length) {
            <div class="card-section card-section-workplace">
              <div class="card-label">{{ item.selfAnswered ? '回答した職場/店舗' : '集計した職場/店舗' }}</div>
              <!-- 4行分までで、超える分は枠内でスクロールする -->
              <div class="card-scroll">
                @if (item.selfAnswered) {
                  <div>{{ item.selfWorkplace }}</div>
                } @else {
                  @for (wp of item.workplaces; track $index; let last = $last) {
                    <div>{{ wp }}@if (last && item.workplacesOmitted) { など}</div>
                  }
                }
              </div>
            </div>
          }
        </div>
      }
    </div>
    <!-- アンケートがない場合 -->
    @if (managerItems.length === 0) {
      <div class="no-items">
        アンケートがありません。
      </div>
    }
    </div>
    </div>
  }
}
